module.exports = __webpack_public_path__ + "img/4G.08be0497.jpg";